<template>
  <div class="price-period-detail-view">
    <dx-responsive-box>
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-col />
      <dx-col screen="md lg" />
      <dx-col screen="md lg" />

      <dx-item>
        <dx-location :row="0" :col="0" />
        <div class="detail-element-container padding-right">
          Navn:
          <dx-textbox
            :value="row.data.name"
            :read-only="true"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="1" :col="0" />
        <dx-location screen="xs sm" :row="1" :col="0" />
        <div class="detail-element-container padding-right">
          Startdato:
          <dx-textbox
            :value="formatService.stringToDate(row.data.startDate)"
            :read-only="true"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="0" :col="1" />
        <dx-location screen="xs sm" :row="2" :col="0" />
        <div class="detail-element-container">
          Supplier:
          <dx-textbox
            :value="getSupplierById(row.data.supplierId)"
            :read-only="true"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="1" :col="1" />
        <dx-location screen="xs sm" :row="3" :col="0" />
        <div class="detail-element-container">
          Slutdato:
          <dx-textbox
            :value="formatService.stringToDate(row.data.endDate)"
            :read-only="true"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="2" :col="0" />
        <dx-location screen="xs sm" :row="4" :col="0" />
        <div class="detail-element-container padding-right">
          Markup:
          <dx-number-box
            :value="row.data.markup"
            :read-only="true"
            class="textbox-readonly"
            :format="NumberFormatting.percentage">
          </dx-number-box>
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="2" :col="1" />
        <dx-location screen="xs sm" :row="4" :col="0" />
        <div class="detail-element-container padding-top">
          <dx-checkbox
            :value="row.data.active"
            :read-only="true"
            text="Aktiv"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="0" :col="2" :rowspan="5" />
        <dx-location screen="xs sm" :row="5" :col="0" />
        <div>
          <div class="action-button-wrapper">
            <dx-button icon="edit" text="Rediger" @click="$emit('onEditClick', row)" :visible="!row.data.active" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="money" text="Prisliste" @click="$emit('onPrislisteClick', row)" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="plus" text="Importer..." hint="Importer prisliste fra Excel-fil" @click="onUpload(row)" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="preferences" text="Services" @click="$emit('onServicesClick', row)" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="upload" text="Aktiver" @click="$emit('onActivateClick', row)" :visible="!row.data.active" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="download" text="Inaktiver" @click="$emit('onInactivateClick', row)" :visible="row.data.active" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="copy" text="Kopier" @click="$emit('onCopyClick', row)" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="trash" text="Slet" @click="$emit('onDeleteClick', row)" :visible="!row.data.active" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="chart" text="Markup" @click="$emit('onMarkupClick', row)" :visible="!row.data.active" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="chart" text="Prisindeks" @click="$emit('onPriceindexClick', row)" :visible="!row.data.active" class="action-button" />
          </div>
        </div>
      </dx-item>
    </dx-responsive-box>
    <FileUploadPopup v-if="showUploadFilePopup"
      title="Upload prisliste"
      saveButtonText="Upload"
      :visible="showUploadFilePopup"
      :height="400"
      :isLoading="isLoading"
      @save="onUploadSaveClick"
      @cancel="onUploadCancel"
      :allowMultipleFiles="false"
      selectButtonText="Vælg prisliste fil"
      labelText="eller drop fil her"
      :allowedFileExtensions="['.xlsx']"
      invalidFileExtensionMessage="Filtypen er forkert. Kun xlsx er tilladt.">
      Filens format skal svare til den Excel-fil, der kan eksporteres fra prislistevisningen.
    </FileUploadPopup>
  </div>
</template>

<script>
import { get } from 'lodash';
import { inject, ref } from 'vue';
import NumberFormatting from '@/constants/number.formatting.js';
import FileUploadPopup from '@/components/common/file-upload-popup.vue';
import usePricePeriodRepository from '@/modules/pricePeriods/repositories/priceperiod.repository.js';
import store from '@/store/index';

export default {
  name: 'DetailView',
  props: {
    row: Object,
    supplierList: Array,
  },
  components: {
    FileUploadPopup,
  },
  setup(props) {
    const formatService = inject('formatService');
    const PricePeriodRepository = usePricePeriodRepository();

    function getSupplierById(id) {
      const supplier = props.supplierList.find((x) => x.id === id);

      return get(supplier, ['name']);
    }

    const showUploadFilePopup = ref(false);
    const isLoading = ref(false);
    const selectedRow = ref(null);

    const onUpload = (row) => {
      showUploadFilePopup.value = true;
      selectedRow.value = row;
    };

    const onUploadSaveClick = async (event) => {
      event.preventDefault();

      const formData = new FormData(event.target);
      formData.append('priceListId', selectedRow.value.key);

      try {
        isLoading.value = true;
        const response = await PricePeriodRepository.importPriceList(selectedRow.value.key, formData);

        const { data } = response;
        const { success, value } = data;

        if (success) {
          showUploadFilePopup.value = false;
          store.dispatch('addSuccessNotification', 'Prisliste importeret');

          // Check if a file is returned
          if (value?.fileContent && value?.fileName) {
            // Convert Base64 to byte array
            const byteCharacters = atob(value.fileContent);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray]);
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = value.fileName;
            link.click();
            URL.revokeObjectURL(link.href);
          }
        } else {
          store.dispatch('addNotifications', { messageList: response.data.messages });
        }
      } catch (err) {
        store.dispatch('addInfoNotification', 'Der skete en fejl under importen af prislisten');
      } finally {
        isLoading.value = false;
      }
    };

    const onUploadCancel = () => {
      showUploadFilePopup.value = false;
    };

    return {
      getSupplierById,
      NumberFormatting,
      formatService,
      showUploadFilePopup,
      onUpload,
      onUploadSaveClick,
      onUploadCancel,
      isLoading,
    };
  },
};
</script>

<style lang="scss">
.price-period-detail-view {
  .action-button-wrapper {
    display: flex;
    justify-content: flex-end;

    .action-button {
      margin-bottom: 5px;
      width: 140px;
    }
  }

  .dx-checkbox.dx-state-readonly .dx-checkbox-icon {
    border-style: dashed;
    border-color: #ddd;
  }

  .dx-checkbox.dx-state-readonly .dx-checkbox-icon,
  .textbox-readonly {
    background-color: #FAFAFA !important;
  }

  .detail-element-container {
    padding-bottom: 10px;
  }

  .padding-top {
    padding-top: 20px;
  }
}
</style>
